import { configureStore } from '@reduxjs/toolkit'
import trainingReducer from './trainingSlice'
import meetingRoomReducer from './meetingRoomSlice' // <--- add this
import userReducer from './userSlice';
import uiReducer from './uiSlice';
import featureReducer from './featureSlice';

export const store = configureStore({
  reducer: {
    training: trainingReducer,
    meetingRoom: meetingRoomReducer, 
    user: userReducer,
    ui: uiReducer,
    feature: featureReducer
    // ...other slices
  },
})
